import { render } from "./stocks-item.vue?vue&type=template&id=3f400924&ts=true"
import script from "./stocks-item.vue?vue&type=script&lang=ts"
export * from "./stocks-item.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/vladdof/Documents/company-quotes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__